import axiosInstance from '../functions/axiosInstance';
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];
const getResourceEditors = async (resourceId, apiToken = null) => {
    console.log("CALLING SERVER with getresourceeditors")
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'getresourceeditors',
            'resourceid': resourceId,
            'apiToken': apiToken
        },
    }).then((resp) => {
        if (resp?.data) {
            //resp.data is { 'success': true, 'users': users } where users is an array of {userid, name}
            if (resp.data?.success && resp.data.users) {
                return resp.data.users;
            } else {
                console.log("FAILED RESPONSE from getresourceeditors call")
                return null;
            }
        }
        console.log("NO RESPONSE from getresourceeditors call");
    }).catch((error) => { console.log(error); });
};

export default getResourceEditors;